var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Payment',{attrs:{"is-ws-payment":"","title-payment":"Choose Your Workspace Type","used-licenses":_vm.usedLicenses,"user-subscription":_vm.currentWorkspaceSubscription}})}
var staticRenderFns = []

export { render, staticRenderFns }